import React from 'react';

import { useTranslation } from 'react-i18next';

import { Sheet, type SheetHeaderProps } from '@pkg/components';
import { useAppDispatch } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { useManagerFilterProps } from '@app/pages/Prototype/NftManagerPanel/hooks';
import { stageLiquidIDItem } from '@app/store/slices';

import { type NftManagerPanelProps } from '../../NftManagerPanel';

type HeaderProps = Pick<NftManagerPanelProps, 'onClose'>;

export function Header({ onClose }: HeaderProps) {
    const [translate] = useTranslation('yat_nft_manager');
    const { tablet } = useMediaQuery();
    const dispatch = useAppDispatch();

    const { onUpdateSearchValue, searchValue } = useManagerFilterProps();

    const handleSearchInput: SheetHeaderProps['onSearchInput'] = ({ target }) => {
        onUpdateSearchValue(target.value);
    };

    const handleSearchClear: SheetHeaderProps['onSearchClear'] = () => {
        onUpdateSearchValue('');
    };

    const handlePanelClose: SheetHeaderProps['onClose'] = () => {
        dispatch(stageLiquidIDItem(undefined));
        onClose();
    };

    return (
        <Sheet.Header
            showSearch
            searchValue={searchValue}
            searchPlaceholder={
                tablet
                    ? translate('yat_nft_manager_search_placeholder_desktop')
                    : translate('yat_nft_manager_search_placeholder_mobile')
            }
            onSearchInput={handleSearchInput}
            onSearchClear={handleSearchClear}
            onClose={handlePanelClose}
        />
    );
}
